<!-- <nav class="navbar navbar-expand-lg navbar-light bg-light bg-black nav-pos">
  <div class="container bg-black">
    <div class="col-md-7 img-svg">
      <div class="w-161">
        <a [innerHTML]="svgContent" (click)="onClickLogo()"></a>
      </div>
    </div>
    <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvas1"
      aria-controls="offcanvasExample">
      <span class="navbar-toggler-icon" style="background-image: url(../../../../assets/SVG/Button.png);"></span>
    </button>
    <div class="col-md-5 collapse navbar-collapse" [ngClass]="{'show': !isCollapsed}" id="navbarText">
      <ul class="navbar-nav mb-2 mb-lg-0 nav-br">
        <li class="nav-item text-center">
          <a class="nav-link active mt-7 siz-12" aria-current="page" href="#">Home</a>
        </li>
        <li class="nav-item text-center">
          <a class="nav-link active mt-7 siz-12" aria-current="page" style="cursor: pointer;"
            (click)="scrollDownToAboutus()">About Us</a>
        </li>
        <li class="nav-item text-center">
          <a class="nav-link active mt-7 siz-12" aria-current="page" style="cursor: pointer;"
            (click)="scrollDownToContactus()">Email Us</a>
        </li>
        <li class="nav-item text-center d-flex justify-content-center siz-12">
          <a class="nav-link active " aria-current="page"><button class="nav-link active sign-bt" (click)="SignInOpen()"
              style="color:  #FFFFFF; width: 130px; height: 50px; background-color: rgba(173, 26, 0, 1); margin-top: -7px; "
              routerLink="gameDay/signin">Sign
              In</button></a>
        </li>
      </ul>

    </div>
  </div>
</nav>

<div class="offcanvas offcanvas-end mob_sidenav" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
  id="offcanvas1">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">&nbsp;</h5>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <a class="nav-link active mt-7 siz-12" style="color:#fff !important" aria-current="page" href="#">Home</a>
    <a class="nav-link active mt-7 siz-12" aria-current="page" style="cursor: pointer;"
      (click)="scrollDownToAboutus()">About Us</a>
    <a class="nav-link active mt-7 siz-12" aria-current="page" style="cursor: pointer;"
      (click)="scrollDownToContactus()">Email Us</a>
      <br>
      <a class="nav-link active " aria-current="page"><button class="nav-link active sign-bt"
        (click)="SignInOpen()"
        style="color:  #FFFFFF; width: 130px; height: 50px; background-color: rgba(173, 26, 0, 1); margin-top: -7px; "
        routerLink="gameDay/signin">Sign
        In</button></a>
  </div>
</div> -->

<nav class="navbar navbar-expand-lg navbar-light bg-light bg-black">
  <div class="container bg-black">
    <div class="col-md-7 img-svg">
      <div class="w-161">
        <!-- (click)="onClickLogo()" -->
        <a [innerHTML]="svgContent" routerLink="/"></a>
      </div>
    </div>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvas1"
      aria-controls="offcanvasExample"
      (click)="showOffCanvas()"
    >
      <span
        class="navbar-toggler-icon"
        style="background-image: url(../../../../assets/SVG/Button.png)"
      ></span>
    </button>
    <div
      class="col-md-5 collapse navbar-collapse"
      [ngClass]="{ show: !isCollapsed }"
      id="navbarText"
    >
      <ul class="navbar-nav mb-2 mb-lg-0 nav-br">
        <li class="nav-item text-center">
          <a class="nav-link active mt-7 siz-12" aria-current="page" href="#"
            >Home</a
          >
        </li>
        <li class="nav-item text-center">
          <a
            class="nav-link active mt-7 siz-12"
            aria-current="page"
            style="cursor: pointer"
            routerLink="/about-us"
            >About Us</a
          >
          <!-- (click)="scrollDownToAboutus()" -->
        </li>
        <li class="nav-item text-center">
          <a
            class="nav-link active mt-7 siz-12"
            routerLink="/contact-us"
            aria-current="page"
            style="cursor: pointer"
            >Contact Us</a
          >
          <!-- <a class="nav-link active mt-7 siz-12" aria-current="page" style="cursor: pointer;"
            (click)="scrollDownToContactus()">Contact Us</a> -->
        </li>
        <li class="nav-item text-center d-flex justify-content-center siz-12">
          <a class="nav-link active" aria-current="page"
            ><button
              class="nav-link active sign-bt"
              (click)="SignInOpen()"
              style="
                color: #ffffff;
                width: max-content;
                background-color: rgba(173, 26, 0, 1);
                padding: 13px 36px;
              "
            >
              Sign In
            </button></a
          >
        </li>
      </ul>
    </div>
  </div>
</nav>

<!-- <button class="btn btn-primary" type="button" >
  Open
</button> -->

<div
  class="offcanvas offcanvas-end mob_sidenav"
  tabindex="-1"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  id="offcanvas1"
  >
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">&nbsp;</h5>
    <mat-icon
      data-bs-dismiss="offcanvas"
      id="homePageMobSidNav"
      aria-label="Close"
      >close</mat-icon
    >
    <!-- <button type="button" class="btn-close text-reset" style="color: #fff !important;" data-bs-dismiss="offcanvas" aria-label="Close"></button> -->
  </div>
  <div class="offcanvas-body" style="padding: 20px; position: relative; z-index: 1;">
    <a
      class="nav-link active mt-7 siz-12"
      style="color: #fff !important; cursor: pointer; display: block; padding: 15px 0; text-decoration: none;"
      aria-current="page"
      routerLink="/"
      data-bs-dismiss="offcanvas"
      >Home</a
    >
    <a
      class="nav-link active mt-7 siz-12"
      aria-current="page"
      style="cursor: pointer; display: block; padding: 15px 0; text-decoration: none; color: #fff !important;"
      routerLink="/about-us"
      data-bs-dismiss="offcanvas"
      >About Us</a
    >
    <a
      class="nav-link active mt-7 siz-12"
      aria-current="page"
      style="cursor: pointer; display: block; padding: 15px 0; text-decoration: none; color: #fff !important;"
      routerLink="/contact-us"
      data-bs-dismiss="offcanvas"
      >Contact Us</a
    >
    <br />
    <a class="nav-link active" aria-current="page" style="display: block; padding: 15px 0;">
      <button
        class="nav-link active sign-bt"
        (click)="SignInOpen()"
        style="
          color: #ffffff;
          width: max-content;
          background-color: rgba(173, 26, 0, 1);
          padding: 13px 36px;
          margin-top: -7px;
          border: none;
          cursor: pointer;
        "
        data-bs-dismiss="offcanvas"
      >
        Sign In
      </button>
    </a>
  </div>
</div>
